<template>
  <div class="picker_color">
    <label>{{
      localStorage.translations.pages['setting-roles'].labels['vyberite-tsvet-roli']
    }}</label>
    <div class="wrapper_color_btn">
      <transition name="fade" mode="out-in">
        <v-skeleton-loader
          v-if="this.$route.name === 'SettingRolesUpdate' && !backColor"
          height="36px"
          type="list-item"
        />
        <v-menu
          v-else
          v-model="menu"
          offset-y
          open-on-click
          :close-on-click="closeOnClick"
          :close-on-content-click="closeOnContentClick"
        >
          <template v-slot:activator="{ on }">
            <div
              class="color_btn"
              v-on="on"
              v-bind:style="{
                backgroundColor: colorPick,
                color: textColor,
              }"
            >
              {{ name || localStorage.translations.pages['setting-roles'].labels['nazvanie-roli'] }}
            </div>
          </template>
          <v-list class="list_down_left">
            <v-color-picker
              class="ma-2"
              show-swatches
              v-model="colorPick"
              @input="onColor"
            ></v-color-picker>
            <v-btn color="primary f16" text @click="menu = false">{{
              localStorage.translations.pages.common.buttons['sohranit']
            }}</v-btn>
          </v-list>
        </v-menu>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RolesColorPickerBtn',
  props: ['name', 'textColor', 'backColor'],
  components: {},
  data: () => ({
    colorPick: '#FFFF00FF',
    menu: false,
    closeOnClick: true,
    closeOnContentClick: false,
  }),
  methods: {
    onColor() {
      this.$emit('onColorPick', this.colorPick)
    },
  },
  created() {
    this.onColor()
  },
  watch: {
    backColor() {
      this.colorPick = this.backColor
    },
  },
  mounted() {
    if (this.backColor) {
      this.colorPick = this.backColor
    }
  },
}
</script>

<style lang="scss" scoped>
.picker_color:deep() {
  display: grid;
  grid-row-gap: 10px;
  grid-template-rows: max-content;
  label {
    font-size: 14px;
  }
  .v-skeleton-loader {
    &__list-item {
      padding: 0;
      .v-skeleton-loader__text {
        height: 100%;
      }
    }
  }
  .v-menu__content {
    .v-list-item:hover {
      background-color: inherit !important;
    }
  }
  .color_btn {
    cursor: pointer;
    border: 2px solid #dddada;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 14px;
    line-height: 16px;
    width: max-content;
  }
}
:deep() .v-btn {
  &__content {
    font-size: 0.875rem !important;
  }
}
</style>
